import { render, staticRenderFns } from "./Agentkbankonly.vue?vue&type=template&id=01ea8826"
import script from "./Agentkbankonly.vue?vue&type=script&lang=js"
export * from "./Agentkbankonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports